import { LOCALES } from '../constants';

export default {
  [LOCALES.ENGLISH]: {
    'email': 'Email',
    'log In': 'Log In',
    'VerificationCode': 'Verification code sent to your email',
  },
};
